import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SosQuestion} from '../../../../../shared/models/response/sos-question';
import {NbDialogRef} from '@nebular/theme';
import {CommonService} from '../../../../../shared/services/common.service';
import {FormService} from '../../../../../shared/services/form.service';
import {CompanyService} from '../../../../../shared/services/company.service';
import { ComponentPermission } from '../../../../../component.permission';
import { Constant } from '../../../../../shared/common/constant';
import { SearchRequest } from '../../../../../shared/models/request/search-request';
import { Company } from '../../../../../shared/models/response/prospect/company';
import { CompanyUtils } from '../../../../../shared/common/company-utils';

@Component({
  selector: 'ngx-prospect-company-create',
  templateUrl: './prospect-company-create.component.html',
  styleUrls: ['./prospect-company-create.component.scss'],
})
export class ProspectCompanyCreateComponent implements OnInit {

  ComponentPermission = ComponentPermission;
  form: FormGroup;
  isSubmitted = false;
  brands: string[] = [];

  @Input()
  sosQuestions: SosQuestion[];

  constructor(protected ref: NbDialogRef<ProspectCompanyCreateComponent>,
              private companyService: CompanyService,
              private commonService: CommonService,
              private formService: FormService) {
  }

  ngOnInit(): void {
    this.initForm();
    this.loadBrands();
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl('', [
        Validators.required,
      ]),
      brand: new FormControl('', [
        Validators.required,
      ]),
      address: new FormControl('', [
        Validators.required,
      ]),
      phone: new FormControl(''),
      email: new FormControl(''),
      type: new FormControl('', Validators.required),
    });
  }

  submit() {
    const self = this;
    this.form.controls.brand.setValue((this.form.controls.brand.value || '').trim());
    const form = this.form.value;
    this.formService.extractErrorMessage(this.form);
    if (this.form.invalid) {
      this.isSubmitted = true;
      return;
    }
    this.companyService.create(form).subscribe(
      result => {
        this.commonService.info('Created success.');
        this.ref.close(result);
      },
      error => {
        this.commonService.warningHtml(error.message);
      },
    );
  }

  cancel() {
    this.ref.close();
  }

  showError(name: string): string {
    return this.form.controls[name]
    && this.form.controls[name].errors
    && (this.form.controls[name].dirty
      || this.form.controls[name].touched
      || this.isSubmitted) ? 'has-error' : '';
  }

  get COMPANY_TYPE() {
    return Constant.COMPANY_TYPE;
  }

  private loadBrands(): void {
    const request = new SearchRequest();
    request.offset = 0;
    request.limit = 10000;
    request.conditions = [];
    request.orders = [{ left: 'name', right: 'ASC' }];
    this.companyService.search(request).subscribe(result => {
      this.brands = CompanyUtils.brands(result.data as Company[]);
    });
  }
}
